import { useState } from "react";

interface BpsLogoProps {
  size?: number;        // px, default 32
  className?: string;
}

/** Tampilkan logo-bps.png dari /public. Fallback ke teks "BPS" jika file belum ada. */
export default function BpsLogo({ size = 32, className = "" }: BpsLogoProps) {
  const [error, setError] = useState(false);

  if (error) {
    // Fallback: lingkaran putih dengan teks BPS
    return (
      <div
        className={`bg-white rounded-full flex items-center justify-center flex-shrink-0 ${className}`}
        style={{ width: size, height: size }}
      >
        <span
          className="text-[#003580] font-black"
          style={{ fontSize: size * 0.28 }}
        >
          BPS
        </span>
      </div>
    );
  }

  return (
    <img
      src="/logo-pst.png"
      alt="Logo PST BPS"
      width={size}
      height={size}
      className={`object-contain flex-shrink-0 ${className}`}
      onError={() => setError(true)}
    />
  );
}
